import { AppWhite } from 'appconstants/AppColors'

export const toolbarStyle = {
  height: { sx: '60px', md: '60px' },
  background: { xs: AppWhite, md: AppWhite },
  boxShadow: 0,
}
